import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CalendarIcon = props => {
  return (
    <Svg
      width={16}
      height={15}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.833.208c.346 0 .625.28.625.625v1.39c2.357-.21 4.727-.21 7.084 0V.833a.625.625 0 111.25 0v1.514a2.813 2.813 0 012.393 2.415l.072.544a24.16 24.16 0 01-.077 6.89 2.508 2.508 0 01-2.232 2.11l-.995.099c-2.629.26-5.277.26-7.906 0l-.995-.098a2.508 2.508 0 01-2.232-2.11 24.162 24.162 0 01-.077-6.89l.072-.545a2.813 2.813 0 012.393-2.415V.833c0-.345.28-.625.625-.625zm.371 3.294a38.675 38.675 0 017.592 0l.754.075c.723.071 1.3.63 1.396 1.35l.072.544c.025.19.048.38.069.57H1.913c.02-.19.044-.38.069-.57l.072-.544a1.563 1.563 0 011.396-1.35l.754-.075zm-2.39 3.79a22.912 22.912 0 00.242 4.712 1.258 1.258 0 001.12 1.059l.993.098c2.548.251 5.114.251 7.662 0l.994-.098a1.258 1.258 0 001.12-1.059c.242-1.56.323-3.139.24-4.712H1.815z"
        fill="#5C697B"
      />
    </Svg>
  );
};

export default CalendarIcon;
